/* import __COLOCATED_TEMPLATE__ from './link-embed-body.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();